import * as runtypes from 'runtypes';
import * as institutionTag from 'src/models/institutionTag';

export const InstitutionFilter = runtypes.Record({
  text: runtypes.String,
  tag: institutionTag.types.InstitutionTag
});

export type InstitutionFilter = runtypes.Static<typeof InstitutionFilter>;
